import Vue from 'vue';
import { vsprintf } from 'sprintf-js'
import QuestionApp from '../components/QNA/NccQuestionApp'
import store from "../store";

const __ = (str = '', args = []) => {
  if(!translations[str]) {
    return '~' + str + '~'
  }
  return vsprintf(translations[str], args);
};

Vue.mixin({
  methods: {
    __(str = '', args = []) {
      return __(str, args);
    }
  }
});

(() => {
  new Vue({
    store,
    el: '#question-app',
    render: h => h(QuestionApp)
  }).$mounted
})();
